var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDynamicsCrm = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13959_2215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916667 0.5H6.75909C7.02277 0.5 7.27368 0.612058 7.44771 0.807543L11.0004 4.79801L14.5523 0.807609C14.7263 0.612083 14.9773 0.5 15.241 0.5H21.0833C21.5896 0.5 22 0.905029 22 1.40466V7.03901C22 7.25569 21.9212 7.46517 21.7779 7.62934L11.6946 19.1856C11.3289 19.6048 10.6711 19.6048 10.3053 19.1856L0.222042 7.62934C0.0787896 7.46517 0 7.25569 0 7.03903V1.40466C0 0.905029 0.410405 0.5 0.916667 0.5Z",
    fill: "url(#paint0_linear_13959_2215)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13959_2215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2414 0.5H21.0838C21.5901 0.5 22.0005 0.905029 22.0005 1.40466V7.03901C22.0005 7.25569 21.9217 7.46517 21.7784 7.62934L11.6951 19.185C11.3294 19.6041 10.6716 19.6041 10.3059 19.185L4.31055 12.3142L14.5528 0.807609C14.7268 0.612083 14.9777 0.5 15.2414 0.5Z",
    fill: "url(#paint1_linear_13959_2215)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    filter: "url(#filter0_f_13959_2215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75909 0.952148H0.916667C0.410405 0.952148 0 1.35718 0 1.85681V7.49118C0 7.70784 0.0787896 7.91732 0.222042 8.08149L10.3053 19.6378C10.6711 20.0569 11.3289 20.0569 11.6946 19.6378L17.6906 12.7648L7.44771 1.25969C7.27368 1.06421 7.02277 0.952148 6.75909 0.952148Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_13959_2215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75909 0.585938H0.916667C0.410405 0.585938 0 0.990969 0 1.4906V7.12497C0 7.34163 0.0787896 7.55111 0.222042 7.71528L10.3053 19.2716C10.6711 19.6908 11.3289 19.6907 11.6946 19.2715L17.6906 12.3986L7.44771 0.893481C7.27368 0.697995 7.02277 0.585938 6.75909 0.585938Z",
    fill: "black",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.75909 0.5H0.916667C0.410405 0.5 0 0.905029 0 1.40466V7.03903C0 7.25569 0.0787896 7.46517 0.222042 7.62934L10.3053 19.1856C10.6711 19.6048 11.3289 19.6048 11.6946 19.1856L17.6906 12.3127L7.44771 0.807543C7.27368 0.612058 7.02277 0.5 6.75909 0.5Z",
    fill: "url(#paint2_linear_13959_2215)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0008 4.79785L4.31055 12.3141L10.3059 19.1849C10.6716 19.604 11.3294 19.604 11.6951 19.1849L14.1191 16.4069L17.6911 12.3125L11.0008 4.79785Z",
    fill: "url(#paint3_linear_13959_2215)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13959_2215",
    x: -8,
    y: -7.04785,
    width: 33.6904,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_13959_2215"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_13959_2215",
    x: -0.76,
    y: -0.174062,
    width: 19.2104,
    height: 20.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.38,
    result: "effect1_foregroundBlur_13959_2215"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13959_2215",
    x1: -4.92708,
    y1: -5.15412,
    x2: 11.4389,
    y2: 13.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493452,
    stopColor: "#E4B4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13959_2215",
    x1: 6.41714,
    y1: -1.76164,
    x2: 20.6362,
    y2: 19.5555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8661C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C428B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13959_2215",
    x1: -4.92708,
    y1: -5.15412,
    x2: 11.4389,
    y2: 13.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493452,
    stopColor: "#E4B4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13959_2215",
    x1: -1.41264,
    y1: -0.283872,
    x2: 7.69848,
    y2: 25.6059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894187,
    stopColor: "#9F75D3"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDynamicsCrm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DynamicsCRM.fdc128e3bb884f26b0e8746845140eef.svg";